import { Navigate } from "react-router-dom";

const AppNavigate = ({ to }) => {
  const isExternalUrl = /^https?:\/\//i.test(to);

  if (isExternalUrl) {
    window.location.href = to;
    return null;
  }

  return <Navigate to={to} replace />;
};

export default AppNavigate;
